export const generateSkuCode = (
	itemPrototypeId: number,
	materialId: number,
	sizeId: number
) =>
	itemPrototypeId.toString() +
	materialId.toString().padStart(3, "0") +
	sizeId.toString().padStart(3, "0");
